import * as angular from "angular";
import {IController} from "angular";
import {CustomFieldModel} from "../../models/custom-field.model";
import {PackageConfigurationDialogsService} from "../../services/package-configuration-dialogs.service";
import {SettingsService} from "../../services/settings-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import * as _ from "lodash";

export class PackageCustomFieldsViewComponent implements IController {

  fields: CustomFieldModel[];

  constructor(private packageConfigurationDialogsService: PackageConfigurationDialogsService,
              private settingsService: SettingsService,
              private confirmDialogService: ConfirmDialogService,
              private $log) {
  }

  $onInit() {

  }

  onAddCustomField($event) {
    this.packageConfigurationDialogsService.createCustomField($event)
      .then((fieldToCreate: CustomFieldModel) => {
        this._createCustomField(fieldToCreate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onEditCustomField(field: CustomFieldModel, $event) {
    this.packageConfigurationDialogsService.editCustomField(field, $event)
      .then((fieldToCreate: CustomFieldModel) => {
        this._updateCustomField(fieldToCreate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onDeleteCustomField(field: CustomFieldModel) {
    this.confirmDialogService.confirm('Delete Custom Field', 'Are you sure you want to custom field?', event)
      .then(() => {
        this._deleteCustomField(field.id);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  private _createCustomField(field: CustomFieldModel) {
    this.settingsService.createPackageField(field)
      .then((field: CustomFieldModel) => {
        this.fields = this.fields.concat(field);
      })
  }

  private _updateCustomField(field: CustomFieldModel) {
    this.settingsService.updatePackageField(field.id, field)
      .then((field: CustomFieldModel) => {
        const index = this.fields.findIndex((f) => {
          return field.id === f.id;
        })
        if (index > -1) {
          const fieldsCopy = angular.copy(this.fields);
          fieldsCopy.splice(index, 1, field);

          this.fields = fieldsCopy;
        }
      })
  }

  private _deleteCustomField(id: string) {
    this.settingsService.deletePackageField(id)
      .then((field: CustomFieldModel) => {
        this.fields = _.filter(this.fields, (f) => {
          return f.id !== id;
        })
      })
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('packageCustomFieldsView', {
    bindings: {
      fields: '<'
    },
    template: require('./package-custom-fields-view.html').default,
    controller: PackageCustomFieldsViewComponent
  });
